/**
 * Shiffa Mobile Menu Enhancements
 * Lightweight enhancements for the native header-drawer component
 */

document.addEventListener('DOMContentLoaded', function() {
  const headerDrawer = document.querySelector('header-drawer');
  if (!headerDrawer) return;

  const detailsEl = headerDrawer.querySelector('details');
  if (!detailsEl) return;

  // Stagger animation indices on menu items inside the drawer
  function setAnimationOrder() {
    const items = headerDrawer.querySelectorAll('.menu-drawer__menu-item');
    items.forEach(function(item, index) {
      if (item instanceof HTMLElement) {
        item.style.setProperty('--animation-order', index.toString());
      }
    });
  }

  setAnimationOrder();

  // Swipe-to-close: right swipe closes the drawer on mobile
  let touchStartX = 0;

  headerDrawer.addEventListener('touchstart', function(e) {
    if (e.touches && e.touches[0]) {
      touchStartX = e.touches[0].clientX;
    }
  }, { passive: true });

  headerDrawer.addEventListener('touchend', function(e) {
    if (e.changedTouches && e.changedTouches[0]) {
      const touchEndX = e.changedTouches[0].clientX;
      // Swipe right > 100px to close
      if (touchEndX - touchStartX > 100 && detailsEl.hasAttribute('open')) {
        // Use the component's close method if available, else dispatch Escape
        if (typeof headerDrawer.close === 'function') {
          headerDrawer.close();
        } else {
          headerDrawer.dispatchEvent(new KeyboardEvent('keyup', { key: 'Escape', bubbles: true }));
        }
      }
    }
  }, { passive: true });
});
